import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/hooks";
import { selectManager } from "../../home/homeSlice";
import { PageDS } from "@qivia/ui";

export const DepartmentDashboard = () => {
  const { t } = useTranslation();
  const manager = useAppSelector(selectManager);

  return (
    <PageDS
      title={t("dashboard.summary.title", { firstName: manager?.firstName })}
      supportButton={{
        showMail: true,
      }}
    ></PageDS>
  );
};
